/* global Swiper */
// *******************************************************************************
// 1.0 - Accommodation Slider
// *******************************************************************************

const accommodationSliderElements = document.querySelectorAll('[data-slider="accommodation-slider"]');

const accommodationSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  watchOverflow: true,
  loop: true,
  effect: 'fade',
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

accommodationSliderElements.forEach((el) => {
  const accommodationSliderParent = el.closest('.accommodation-slider__item');
  const paginationElement = accommodationSliderParent.querySelector('.swiper-pagination');
  const arrowRight = accommodationSliderParent.querySelector('.arrow-right');
  const arrowLeft = accommodationSliderParent.querySelector('.arrow-left');

  accommodationSliderOptions.navigation.nextEl = arrowRight;
  accommodationSliderOptions.navigation.prevEl = arrowLeft;
  accommodationSliderOptions.pagination.el = paginationElement;
  // eslint-disable-next-line no-new
  new Swiper(el, accommodationSliderOptions);
});
